import { ReactNode } from 'react'
import clsx from 'clsx'
import classes from './RowContainer.module.css'

export default function RowContainer({
  children,
  isTransparent,
  withSidePadding,
}: {
  children: ReactNode
  isTransparent?: boolean
  withSidePadding?: boolean
}) {
  return (
    <div
      className={clsx(
        classes.container,
        {
          [classes.transparent]: isTransparent,
        },
        {
          [classes.with_side_padding]: withSidePadding,
        }
      )}
    >
      {children}
    </div>
  )
}
